import React from 'react';
import { Outlet } from 'react-router-dom';
import { PAGE_TYPE, SideNavContainer } from '@modules/members/utils';

/* Admin view-member shell for CAP historical notices (`/.../notices/{hhid}?referenceId=…`). */
const CapHistoricalNoticesAdminLayout: React.FC = () => (
    <SideNavContainer page={PAGE_TYPE.HISTORICAL_NOTICES}>
        <main className="desktop:grid-col-9" id="main-content">
            <Outlet />
        </main>
    </SideNavContainer>
);

export default CapHistoricalNoticesAdminLayout;
